// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {
    findMatchingKey,
    isNotEmpty
} from '../../../claim/shared/services/claim-shared-helper';
import Component from '@deere/cps-it.warranty-model-factory/lib/component';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import LabeledInput from '../../../claim/shared/components/claim-fields/labeled-input';
import LabeledInputWithBlur from '../../../claim/shared/components/claim-fields/labeled-input-with-blur';
import LabeledKeyValueDropDown from '../../../claim/shared/components/claim-fields/labeled-key-value-dropdown';

function handlePartNumberKeyDown(event) {

    if (event.keyCode === 9 || event.keyCode === 13) {

        event.preventDefault();
        event.target.blur();

    }

}

function handlePartNumberBlur(partNumber) {

    if (partNumber) {

        this.onPartNumberBlur(partNumber);

    }

}

function handleInputChange(property, data) {

    property === 'code' ?
        this.onInputChange(property, data.target.value) :
        this.onInputChange(property, data);

}

function handleButtonClick() {

    this.onCreateComponent();

}

const AddComponentForm = props =>
    <div className='add-component-form'>
        <LabeledInputWithBlur
            className='part-number'
            errorMessage='PART_NUMBER_IS_REQUIRED'
            isEditable={true}
            isValid={true}
            label='PART_NUMBER'
            onBlur={props::handlePartNumberBlur}
            onChange={handleInputChange.bind(props, 'partNumber')}
            onKeyDown={handlePartNumberKeyDown}
            value={props.component.partNumber}
        />
        <LabeledInput
            className='description'
            isEditable={false}
            label='DESCRIPTION'
            value={props.component.description}
        />
        {props.showAddComponentRow &&
            <LabeledInput
                autoFocus={true}
                className='serial-number'
                isEditable={true}
                label='SERIAL_NUMBER'
                onChange={handleInputChange.bind(props, 'serialNumber')}
                value={props.component.serialNumber}
            />
        }
        {props.showAddComponentRow &&
            <LabeledKeyValueDropDown
                className='component-code'
                isEditable={true}
                isValid={true}
                label='COMPONENT_CODE'
                list={props.componentCodes}
                onChange={handleInputChange.bind(props, 'code')}
                selectedValue={findMatchingKey(props.component.code, props.componentCodes)}
            />
        }
        <button
            className='create-button'
            disabled={!(isNotEmpty(props.component.partNumber) && isNotEmpty(props.component.serialNumber) && isNotEmpty(props.component.code))}
            onClick={props::handleButtonClick}
        >
            <FormattedMessage id='ADD_COMPONENT'/>
        </button>

    </div>;

AddComponentForm.displayName = 'AddComponentForm';
AddComponentForm.propTypes = {
    component: PropTypes.instanceOf(Component).isRequired,
    componentCodes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    onCreateComponent: PropTypes.func.isRequired,
    onInputChange: PropTypes.func.isRequired,
    onPartNumberBlur: PropTypes.func.isRequired,
    showAddComponentRow: PropTypes.bool.isRequired
};

export default AddComponentForm;



// WEBPACK FOOTER //
// ./src/product/details/components/add-component-form.js